import { Fragment, React } from "react";
import "animate.css";

import styles from "./TopBar.module.css";
import { Link, NavLink } from "react-router-dom";
function TopBar(props) {
  return (
    <Fragment>
      <Link className={styles.brand} to="/">
        Arrafi<span className={styles.important}>Mahin</span>
      </Link>

      <ul className={`${styles.navBar} navBar`}>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/">
            HOME
          </NavLink>
        </li>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/about">
            ABOUT ME
          </NavLink>
        </li>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/skills">
            SKILLS
          </NavLink>
        </li>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/experience">
            EXPERIENCE
          </NavLink>
        </li>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/portfolio">
            PORTFOLIO
          </NavLink>
        </li>
        <li className={styles.navItem}>
          <NavLink className={styles.navLink} to="/contact">
            CONTACT
          </NavLink>
        </li>
      </ul>
    </Fragment>
  );
}

export default TopBar;
